<template>
    <div class="consultation-header">
        <div>
            <img src="@/assets/image/sp.png" alt="" style="width:100%;margin-top: 80px;">
        </div>
        <div>
          <div class="header-first">
              <div style="font-size: 40px;color: #262A47;text-align:center;margin-top:59px;margin-bottom:55px">高清音视频</div>
              <div style="display:flex;">
                  <img src="@/assets/image/gq1.png" alt="" style="width:659px">
                  <div style="margin-top:46px;margin-left:102px">
                      <div style="display:flex">
                          <img src="@/assets/image/sp1.png" alt="" style="width:30px;height:30px;margin-top:5px">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;line-height: 36px;">视频</div>
                              <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">支持1080P高清视频，多码流全速率适配，多画面布局模板，支持网络自适应显示</p>
                          </div>
                      </div>
                      <div style="display:flex;margin-top:58px">
                          <img src="@/assets/image/yp1.png" alt="" style="width:30px;height:30px;margin-top:5px">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;line-height: 36px;">音频</div>
                              <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">支持上百路音频同时打开，有效音频背景噪声、回声消除处理，兼容各种硬件使用</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="header-send">
              <div style="width:1200px;margin:0 auto">
                   <div style="font-size: 40px;color: #262A47;text-align:center;padding-top:61px;margin-bottom:55px">全平台支持</div>
                   <div style="display:flex">
                       <div>
                        <div style="margin-left:45px;margin-top:126px">
                            <div style="display:flex">
                                <img src="@/assets/image/kh4.png" alt="" style="width:30px;height:30px;margin-top:5px">
                                <div style="margin-left:8px">
                                    <div style="font-size: 24px;color: #000000;line-height: 36px;">软件客户端</div>
                                    <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">支持 Windows\Mac\Android\iOS\国产化\Web 全平台的客户端软件和SDK</p>
                                </div>
                            </div>
                            <div style="display:flex;margin-top:58px">
                                <img src="@/assets/image/fu4.png" alt="" style="width:30px;height:30px;margin-top:5px">
                                <div style="margin-left:8px">
                                    <div style="font-size: 24px;color: #000000;line-height: 36px;">硬件终端</div>
                                    <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">提供分体终端、一体终端、桌面终端、大屏等终端及配置音视频硬件，满足大中小各类会议室使用场景</p>
                                </div>
                            </div>
                        </div>
                       </div>
                       <div>
                           <img src="@/assets/image/sh.png" alt="" style="margin-left:100px">
                       </div>
                   </div>
              </div>
          </div>
         <div class="header-first1">
              <div style="font-size: 40px;color: #262A47;text-align:center;margin-top:59px;margin-bottom:55px">快捷协同共享</div>
              <div style="display:flex;">
                  <img src="@/assets/image/kj1.png" alt="" >
                  <div style="margin-top:30px">
                      <div style="display:flex">
                          <img src="@/assets/image/zm.png" alt="" style="width:30px;height:30px;margin-top:5px">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;line-height: 36px;">桌面/程序共享</div>
                              <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">一键共享手机、电脑屏幕和应用程序</p>
                          </div>
                      </div>
                      <div style="display:flex;margin-top:28px">
                          <img src="@/assets/image/bb.png" alt="" style="width:30px;height:30px;margin-top:5px">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;line-height: 36px;">会议白板</div>
                              <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">参会者可以在白板上使用激光笔、画笔、文本、图形等多种工具协同</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
         <div class="header-send1">
              <div style="width:1200px;margin:0 auto">
                   <div style="font-size: 40px;color: #262A47;text-align:center;padding-top:61px;margin-bottom:55px">安全、可控</div>
                   <div style="display:flex">
                       <div>
                        <div style="margin-left:45px;margin-top:70px">
                            <div style="display:flex">
                                <img src="@/assets/image/aqs.png" alt="" style="width:30px;height:30px;margin-top:5px">
                                <div style="margin-left:8px">
                                    <div style="font-size: 24px;color: #000000;line-height: 36px;">安全控制</div>
                                    <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">会前，账号密码、会议密码多重认证；会中，多角色会控、权限设设置、会议室锁定</p>
                                </div>
                            </div>
                            <div style="display:flex;margin-top:45px">
                                <img src="@/assets/image/aqy.png" alt="" style="width:30px;height:30px;margin-top:5px">
                                <div style="margin-left:8px">
                                    <div style="font-size: 24px;color: #000000;line-height: 36px;">安全加密</div>
                                    <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">支持数据的端到端数据加密，让数据传输更可靠</p>
                                </div>
                            </div>
                        </div>
                       </div>
                       <div>
                           <img src="@/assets/image/aq.png" alt="" style="margin-left:146px">
                       </div>
                   </div>
              </div>
          </div>
         <div class="header-first2">
              <div style="font-size: 40px;color: #262A47;text-align:center;margin-top:59px;margin-bottom:55px">会议录制</div>
              <div style="display:flex;">
                  <img src="@/assets/image/lz1.png" alt="" >
                  <div style="margin-left:78px;margin-top:70px">
                      <div style="display:flex">
                          <img src="@/assets/image/flz.png" alt="" style="width:30px;height:30px;margin-top:5px">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;line-height: 36px;">服务器端录制</div>
                              <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">直接录制在服务器端，并可以直接进行在线管理、下载和点播</p>
                          </div>
                      </div>
                      <div style="display:flex;margin-top:45px">
                          <img src="@/assets/image/bd.png" alt="" style="width:30px;height:30px;margin-top:5px">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;line-height: 36px;">本地录制</div>
                              <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">直接录制为标准媒体格式到本地电脑</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        <div class="header-send2">
              <div style="width:1200px;margin:0 auto">
                   <div style="font-size: 40px;color: #262A47;text-align:center;padding-top:61px;margin-bottom:55px">H323/SIP终端连接器</div>
                   <div style="display:flex">
                       <div>
                        <div style="margin-left:45px;margin-top:120px">
                            <div style="display:flex">
                                <img src="@/assets/image/hji.png" alt="" style="width:30px;height:30px;margin-top:5px">
                                <div style="margin-left:8px">
                                    <div style="font-size: 24px;color: #000000;line-height: 36px;">终端呼叫</div>
                                    <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">支持一键呼叫H323/SIP 硬件终端，充分结合和利用客户已有的视频会议设备</p>
                                </div>
                            </div>
                            <div style="display:flex;margin-top:45px">
                                <img src="@/assets/image/ht.png" alt="" style="width:30px;height:30px;margin-top:5px">
                                <div style="margin-left:8px">
                                    <div style="font-size: 24px;color: #000000;line-height: 36px;">MCU互通</div>
                                    <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">支持与客户已有MCU的呼入和呼出，实现与MCU中会议的无缝对接</p>
                                </div>
                            </div>
                        </div>
                       </div>
                       <div>
                           <img src="@/assets/image/zd.png" alt="" style="margin-left:146px">
                       </div>
                   </div>
              </div>
          </div>
          <div class="header-first3">
              <div style="font-size: 40px;color: #262A47;text-align:center;margin-top:59px;margin-bottom:55px">AI智能应用</div>
              <div style="display:flex;">
                  <img src="@/assets/image/ai1.png" alt="" >
                  <div style="margin-left:149px;margin-top:80px">
                      <div style="display:flex">
                          <img src="@/assets/image/sy.png" alt="" style="width:30px;height:30px;margin-top:5px">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;line-height: 36px;">双语字幕</div>
                              <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">会议语音沟通实时转为中英文字幕展示，并保存为会议纪要</p>
                          </div>
                      </div>
                      <div style="display:flex;margin-top:45px">
                          <img src="@/assets/image/xn.png" alt="" style="width:30px;height:30px;margin-top:5px">
                          <div style="margin-left:8px">
                              <div style="font-size: 24px;color: #000000;line-height: 36px;">虚拟背景</div>
                              <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">自定义视频背景，打造个性化视频体验</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="header-send3">
              <div style="width:1200px;margin:0 auto">
                   <div style="font-size: 40px;color: #262A47;text-align:center;padding-top:61px;margin-bottom:55px">大容量、多级网络架构支持</div>
                   <div style="display:flex">
                       <div>
                        <div style="margin-left:45px;margin-top:120px">
                            <div style="display:flex">
                                <img src="@/assets/image/drl.png" alt="" style="width:30px;height:30px;margin-top:5px">
                                <div style="margin-left:8px">
                                    <div style="font-size: 24px;color: #000000;line-height: 36px;">大容量支持</div>
                                    <p style="width: 446px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">根据客户需要提供大规模用户分布式架构，可灵活伸缩架构</p>
                                </div>
                            </div>
                            <div style="display:flex;margin-top:45px">
                                <img src="@/assets/image/fzw.png" alt="" style="width:30px;height:30px;margin-top:5px">
                                <div style="margin-left:8px">
                                    <div style="font-size: 24px;color: #000000;line-height: 36px;">复杂网络架构</div>
                                    <p style="width: 400px;height: 52px;font-size: 16px;color: #565E66;line-height: 36px">支持多级网络分布式部署架构，满足各种网络的私有化部署要求</p>
                                </div>
                            </div>
                        </div>
                       </div>
                       <div>
                           <img src="@/assets/image/dr.png" alt="" style="margin-left:146px">
                       </div>
                   </div>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        .header-first{
            height: 490px;
            width:1200px;
            margin:0 auto
        }
        .header-send{
            height: 730px;
            background-color: #EBF3FE;
        }
        .header-first1{
            height: 490px;
            width:1200px;
            margin:0 auto
        }
        .header-send1{
            height: 590px;
            background-color: #EBF3FE;
        }
        .header-first2{
            height: 490px;
            width:1200px;
            margin:0 auto
        }
        .header-send2{
            height: 700px;
            background-color: #EBF3FE;
        }
        .header-first3{
            height: 520px;
            width:1200px;
            margin:0 auto
        }
        .header-send3{
            height: 650px;
            background-color: #EBF3FE;
        }
    }
</style>